import React, { Component } from 'react';
import Show from '../components/settings/Tenants/Show'
import Preloader from '../GeneralComponents/LoadingComponen'

class TenantShow extends Component {
    constructor(props) {
        super(props);
        this.token = document.querySelector("[name='csrf-token']").content;
        this.state = {
            data: [],
            isLoaded: true,
            chart:{}
        }
    }

    componentDidMount(){
        this.loadData();
    }

    updateStateLoad = (state) => {
        this.setState({ isLoaded: state })
    } 

    loadData = () => {
        fetch(`/settings/get_info`, {
            method: 'GET', // or 'PUT'
            headers: {
                "X-CSRF-Token": this.token,
                "Content-Type": "application/json"
            }
        })
        .then(response => response.json())
        .then(data => {
            this.setState({
                data: data.data,
                chart: data.chart,
                isLoaded: false
            });
        });
    }


    render() {
        if(this.state.isLoaded){
            return(
                <div className="card">
                    <div className="card-body">
                        <Preloader />
                    </div>
                </div>
            )
        }

        return (
            <React.Fragment>
                <Show
                    updateStateLoad={this.updateStateLoad}
                    loadData={this.loadData}
                    data={this.state.data}
                    chart={this.state.chart}
                    isLoaded={this.state.isLoaded}
                    user={this.props.user}
                    tenant={this.props.tenant}
                    plans={this.props.plans}
                    current_plan={this.props.current_plan}

                    estados={this.props.estados}
                />
            </React.Fragment>
        );
    }
}


export default TenantShow;


